// auto inicializuje vsechny range inputy s data-range-input-price
// uvnitr nich jsou classami oznacene inputy a view element

import $ from "jquery";
import VOID from "./framework/framework";

const _ = VOID._;

console.warn("range-input-price je obsolentni. range-input ted umi vse.");

const RangeInputView = window.RangeInputView;
const PriceModel = RangeInputView.PriceModel;

const TEMPLATE_NAME = "rangeInputTemplate";
const DATA_ATTR = "data-range-input-price";

function initPriceRangeInputs() {
  $(`[${DATA_ATTR}]`).each(function () {
    const el = this;

    if (el.__priceRangeInputInited) return;

    const $el = $(el);

    let opts;
    try {
      opts = JSON.parse($el.attr(DATA_ATTR));
    } catch (e) {
      console.error("initPriceRangeInputs failed to initialize element", el, e);
      return;
    }

    // two hidden inputs that get sent
    const $from = $el.find(".js-range-slider-group-from");
    const $to = $el.find(".js-range-slider-group-to");

    const min = (!opts.adjust || $from.val() === "") ? +opts.min : Math.min(+$from.val(), +opts.min);
    const max = (!opts.adjust || $to.val() === "") ? +opts.max : Math.max(+$to.val(), +opts.max);

    const form = $el.closest("form").get(0);
    const slider = $el.find(".js-range-slider-group-slider").get(0);

    // two visual inputs that don't get sent
    const $fromVisual = $el.find(".js-range-slider-group-from-visual");
    const $toVisual = $el.find(".js-range-slider-group-to-visual");

    const model = new PriceModel({
      min,
      max,
      visualMin: min,
      visualMax: max,
      step: +opts.step
    });

    const view = new RangeInputView(model, {
      template: TEMPLATE_NAME,
      fromInput: $fromVisual.get(0),
      toInput: $toVisual.get(0)
    });

    const submit = _.boundArgs(AJAX, "handleSubmit", form);
    // const submitDebounced = _.debounce(submit, 400);

    const updateHiddenInputs = () => {
      const from = model.round(model.fromViewSpace(view.from));
      const to = model.round(model.fromViewSpace(view.to));

      // hidden inputs should be empty if in extreme value
      $from.val(from === min ? "" : from);
      $to.val(to === max ? "" : to);
    };

    // update input values
    view.on('change', () => {
      updateHiddenInputs();
      submit();
    });

    // update sliders instantly on change
    const makeChangeHandler = (prop, setter) => function() {
      const valUnclamped = model.toViewSpace(+this.value);
      const val = model.clampViewSpace(valUnclamped);
      if (val !== view[prop]) {
        setter(val);
        updateHiddenInputs();
        submit();
      } else if (val !== valUnclamped) {
        this.value = model.formatInputValue(model.fromViewSpace(val));
      }
    };

    $fromVisual.on("change", makeChangeHandler("from", _.bound(view, "setFrom")));
    $toVisual.on("change", makeChangeHandler("to", _.bound(view, "setTo")));

    view.appendTo(slider);

    el.__priceRangeInputInited = true;
  });
}

$(initPriceRangeInputs);
AJAX.onUpdate(initPriceRangeInputs);